'use strict';

/* global $ */

import { interfaceName } from 'settings';


let settings = {
    selector: '.js-price-list',
    blockSelector: '.js-price-list__block',
    headerSelector: '.js-price-list__header',
    linkSelector: '.js-price-list__link',
    priceSelector: '.js-price-list__price',
    anchorSelector: '.js-price-list__anchor'
};

class PriceList {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ PriceList/init ]');

        let $list = $(this.opt.selector),
            $anchors = $(this.opt.anchorSelector);

        if ($list.length) {
            let $blocks = $list.find(this.opt.blockSelector);

            for (let i = 0; i < $blocks.length; i ++) {
                let $block = $blocks.eq(i);
            
                let $link = $block.find(this.opt.linkSelector),
                    $header = $block.find(this.opt.headerSelector),
                    $price = $block.find(this.opt.priceSelector);

                if (interfaceName == 'service_cat' || interfaceName =='service_group' || interfaceName == 'service') {
                    $link.addClass('is-active');
                    $header.addClass('is-active');
                    $price.fadeIn();
                }

                $link.on('click', function(e) {
                    e.preventDefault();

                    $link.toggleClass('is-active');
                    $header.toggleClass('is-active');
                    $price.fadeToggle();
                    
                    $(window).trigger('resize');
                });
            }

            for (let i = 0; i < $anchors.length; i ++) {
                let $anchor = $anchors.eq(i);

                $anchor.on('click', (e) => {
                    e.preventDefault();

                    let block = $anchor.attr('href');
                    let $link = $(block).find(this.opt.linkSelector),
                        $header = $(block).find(this.opt.headerSelector),
                        $price = $(block).find(this.opt.priceSelector);
                    $link.addClass('is-active');
                    $header.addClass('is-active');
                    $price.fadeIn();
                    
                    $(window).trigger('resize');
                });
            }
        }
    }
}


export {
    PriceList
};
